var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6699 27.5501V10.0833C13.6699 9.36095 13.6699 8.99979 13.8013 8.70688C13.9172 8.44867 14.1037 8.2285 14.3393 8.0718C14.6066 7.89403 14.9629 7.83465 15.6754 7.71591L28.8754 5.51591C29.8368 5.35566 30.3175 5.27554 30.6922 5.4147C31.021 5.53681 31.2966 5.77027 31.4711 6.0745C31.6699 6.42118 31.6699 6.90853 31.6699 7.88325V24.5501M13.6699 27.5501C13.6699 30.0354 11.6552 32.0501 9.16992 32.0501C6.68464 32.0501 4.66992 30.0354 4.66992 27.5501C4.66992 25.0649 6.68464 23.0501 9.16992 23.0501C11.6552 23.0501 13.6699 25.0649 13.6699 27.5501ZM31.6699 24.5501C31.6699 27.0354 29.6552 29.0501 27.1699 29.0501C24.6846 29.0501 22.6699 27.0354 22.6699 24.5501C22.6699 22.0649 24.6846 20.0501 27.1699 20.0501C29.6552 20.0501 31.6699 22.0649 31.6699 24.5501Z",
    stroke: "#EE4950",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicRed);
export default __webpack_public_path__ + "static/media/music-red.4fd67d56533160e0261669f162c8e099.svg";
export { ForwardRef as ReactComponent };